import {
  FC,
  MouseEvent,
  useState,
} from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { DataButton, DataLink } from 'components/Shared/SharedComponents';
import { Block } from 'src/__generated__/graphqlTypes';
import { capitalizeFirstLetter, replaceContentfulVariables } from 'lib/text.service';
import { GAReplacementValue } from 'constants/enums';
import { Store } from 'app-redux/types/storeTypes';

import { ButtonIcon } from './Icon';
import styles from './styles.module.scss';
import Modal from './Modal';

import { MessageButtonInterface } from '../config/declarations';

const MessageButton: FC<MessageButtonInterface> = ({
  button,
  psychic,
  className,
  buttonName,
  shape = 'Rectangle',
  href = '',
  onClick,
  ...rest
}) => {
  const { isAuthenticated } = useSelector((store: Store) => store.server.auth);
  const [isOpened, setOpenedState] = useState<boolean>(false);

  if (!button?.link) {
    return null;
  }

  const { extId, psychicName } = psychic;
  const { link } = button;
  const replacementValues = { extId: `${extId}`, psychicName: psychicName.toLowerCase() };
  const url = replaceContentfulVariables(href || link?.src!, replacementValues);
  const sharedProps = {
    link,
    className: cn(
      styles.button,
      styles[`shape${capitalizeFirstLetter(shape)}`],
      styles[`button${buttonName}`],
      className,
    ),
    gaData: {
      [GAReplacementValue.PSYCHIC_NAME]: psychicName,
      [GAReplacementValue.EXT_ID]: extId.toString(),
    },
    ...rest,
  };
  const children = (
    <>
      <ButtonIcon
        isMessageButton
        image={link.image}
        className={styles.buttonAsset}
        buttonName={buttonName}
      />
      <span className={styles.buttonTitle}>
        {link.title}
      </span>
    </>
  );
  const onClickLocal = (e: MouseEvent<HTMLButtonElement>) => {
    setOpenedState((prev) => !prev);
    onClick?.(e);
  };
  const closeModal = () => setOpenedState(false);

  if (isAuthenticated) {
    return (
      <DataLink
        {...sharedProps}
        href={url}
      >
        {children}
      </DataLink>
    );
  }

  return (
    <>
      <Modal
        isOpened={isOpened}
        buttonTitle={button.title}
        content={(button as Block).content}
        closeModal={closeModal}
      />
      <DataButton
        {...sharedProps}
        onClick={onClickLocal}
      >
        {children}
      </DataButton>
    </>
  );
};

export default MessageButton;
